module.exports = __webpack_public_path__ + "assets/google-logo.3ec228d3.svg";